var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 835,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 836,
	"./assets/thewest-digital-hero-variation-a.jpg": 2832,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 837,
	"./assets/thewest-digital-hero-variation-b.jpg": 2833,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 838,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2834,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 839,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2835,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 840,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2836,
	"./assets/thewest-digital-hero.jpg": 2837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2831;